const config = require('../../../../../config/locales_json/packs/private/validations/activation.json');
const language = $('body').data("language");

// Selectize para país del cliente
$(document).ready(function(){
	$("#form-activation #client_country").selectize({
		create: false
	})
})

$("#form-activation").on("click", "#kt_activation_submit", function(e){
  e.preventDefault()

  const form = $("#form-activation");

  var error = 0;
  const firstName = form.find("#recruiter_first_name");
  const lastName = form.find("#recruiter_last_name");
  const email = form.find("#recruiter_email");
  const password = form.find("#recruiter_password");
  const rePassword = form.find("#recruiter_password_confirmation");

  const clientName = form.find("#client_name");
  const clientCountry = form.find("#client_country");
  const submitBtn = form.find("#kt_activation_submit.recaptcha-conditioned-submit")

  const emailRegex = /^[\w+\-.]+@[a-z\d\-.]+\.[a-z]+$/i;
  const emailVal = email.val().trim();
  const isValidEmail = emailVal ? emailRegex.test(emailVal) : false;

  if(!firstName.val()){
    const errorText = getTranslationValue(config, [language, "first_name_error"],"Debes ingresar un nombre");
    firstName.removeClass("is-invalid").addClass("is-invalid")
    firstName.parent().find(".invalid-feedback").remove()
    firstName.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    firstName.parent().find(".invalid-feedback").remove()
    firstName.removeClass("is-invalid")
  }

  if(!lastName.val()){
    const errorText = getTranslationValue(config, [language, "last_name_error"],"Debes ingresar un apellido");
    lastName.removeClass("is-invalid").addClass("is-invalid")
    lastName.parent().find(".invalid-feedback").remove()
    lastName.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    lastName.parent().find(".invalid-feedback").remove()
    lastName.removeClass("is-invalid")
  }
  
  if(!isValidEmail){
    const errorText = getTranslationValue(config, [language, "email_error"],"Debes ingresar un email");
    email.removeClass("is-invalid").addClass("is-invalid")
    email.parent().find(".invalid-feedback").remove()
    email.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    email.parent().find(".invalid-feedback").remove()
    email.removeClass("is-invalid")
  }

  if(!password.val()){
    const errorText = getTranslationValue(config, [language, "empty_password"],"Debes ingresar una contraseña");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else if(password.val().length < 6){
    const errorText = getTranslationValue(config, [language, "short_password"],"Debes ingresar la cantidad de cararcteres indicados");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    password.parent().find(".invalid-feedback").remove()
    password.removeClass("is-invalid")
  }

  if(!rePassword.val()){
    const errorText = getTranslationValue(config, [language, "empty_re_password"],"Debes ingresar nuevamente tu contraseña");
    rePassword.removeClass("is-invalid").addClass("is-invalid")
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else if(password.val() != rePassword.val()) {
    const errorText = getTranslationValue(config, [language, "password_not_match"],"Las contraseñas no son iguales");
    rePassword.removeClass("is-invalid").addClass("is-invalid")
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.removeClass("is-invalid")
  }

  if(!clientName.val()){
    const errorText = getTranslationValue(config, [language, "client_name_error"],"Debes ingresar el nombre de tu empresa");
    clientName.removeClass("is-invalid").addClass("is-invalid")
    clientName.parent().find(".invalid-feedback").remove()
    clientName.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    clientName.parent().find(".invalid-feedback").remove()
    clientName.removeClass("is-invalid")
  }

  if(!clientCountry.val()){
    const errorText = getTranslationValue(config, [language, "client_name_error"],"Debes ingresar el nombre de tu empresa");
    clientCountry.removeClass("is-invalid").addClass("is-invalid")
    clientCountry.parent().find(".invalid-feedback").remove()
    clientCountry.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    clientCountry.parent().find(".invalid-feedback").remove()
    clientCountry.removeClass("is-invalid")
  }

  if(!submitBtn || !["true", true].includes(submitBtn.data("checked"))){
    const errorText = getTranslationValue(config, [language, "recaptcha_error"],"Es obligatorio completar el recaptcha");
    submitBtn.addClass("disabled");
    submitBtn.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    clientCountry.parent().find(".invalid-feedback").remove()
    submitBtn.removeClass("disabled")
  }

  if(!error){
    const successText = getTranslationValue(config, [language, "not_error_text"],"Activando...");
    $(this).addClass('send-button').text(successText)
    form.submit()
  }
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}
	
	return currentTranslation;
}
